import Splide from '@splidejs/splide'

let ytPlayers = {};

function loadYouTubeAPI(callback) {
	if (window.YT && window.YT.Player) {
		callback();
	} else {
		const tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		window.onYouTubeIframeAPIReady = callback;
	}
}

export function slider() {
	const sliders = [];
	const elms = document.getElementsByClassName('splide');

	loadYouTubeAPI(() => {
		const iframes = document.querySelectorAll('.yt-iframe');
		iframes.forEach(iframe => {
			const id = iframe.id;
			if (id && !ytPlayers[id]) {
				ytPlayers[id] = new YT.Player(id);
			}
		});

		for (let i = 0; i < elms.length; i++) {
			const splide = new Splide(elms[i]);

			splide.on('move', (newIndex) => {
				Object.values(ytPlayers).forEach(player => {
					try {
						player.pauseVideo();
					} catch (e) {}
				});

				const activeSlide = splide.Components.Slides.getAt(newIndex);
				if (activeSlide) {
					const iframe = activeSlide.slide.querySelector('.yt-iframe');
					if (iframe && iframe.id && ytPlayers[iframe.id]) {
						try {
							ytPlayers[iframe.id].playVideo();
						} catch (e) {}
					}
				}
			});

			sliders.push(splide.mount());
		}
	});

	return sliders;
}
